<!--
 * @description: 商品详情介绍
 * @Author: Jay
 * @Date: 2021-09-25 14:30:10
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 10:41:22
-->
<template>
  <div>
    <div v-class="'animate__animated animate__fadeInUp'">
      <el-carousel
        indicator-position="none"
        :autoplay="false"
        height="500px"
        ref="refCarou"
      >
        <el-carousel-item v-for="(item, index) in goodsList" :key="index">
          <div class="info-code flex">
            <img class="code-img" :src="$api + item.images" alt="" />
            <!-- 内容标题 -->
            <div class="padding-left flex-sub">
              <div
                class="
                  text-black
                  font_weight_bold font_size_lg
                  margin-top-xl
                  line-height
                "
              >
                {{ item.goods_name }}
              </div>
              <!-- 符号 -->
              <div class="cuIcon-move font_size_xl text-red"></div>
              <!-- 内容 -->
              <div
                class="
                  text-black
                  font_size_df
                  margin-top-xs margin-right
                  line-height
                  html-scroll
                "
              >
                <div class="scroll-code">
                  <p v-html="item.content"></p>
                </div>
              </div>
              <!-- 符号 -->
              <!-- <div class="text-gray margin-top iconHover">
                <p>
                  <span class="cuIcon-more"></span>
                  <span class="cuIcon-more"></span>
                  <span class="cuIcon-more"></span>
                </p>
                <p>
                  <span class="cuIcon-more"></span>
                  <span class="cuIcon-more"></span>
                  <span class="cuIcon-more"></span>
                </p>
                <p>
                  <span class="cuIcon-more"></span>
                  <span class="cuIcon-more"></span>
                  <span class="cuIcon-more"></span>
                </p>
              </div> -->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "goodsInfo",
  props: ["goodsList", "tabIndex"],
  data() {
    return {};
  },
  computed: {},
  updated() {},
  mounted() {
    console.log(this.tabIndex);
    if (this.tabIndex != "") {
      setTimeout(() => {
        this.seleTap(this.tabIndex);
      }, 1000);
    }
  },
  methods: {
    //动态修改 轮播图
    seleTap(id) {
      // console.log("修改");
      this.$refs.refCarou.setActiveItem(id);
    },
  },
  watch: {
    // 监听xuex  store里获取的商品tab 的值
    "$store.state.goodsDetailsId"(newval) {
      console.log("监听vuex变化 goodsDetailsId", newval);
      this.seleTap(newval);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-code {
  background: url("../../assets/goods-details-bg.png") no-repeat 0 0;
  background-size: 100% 100%;
  background-clip: border-box;
  height: 100%;
}

.code-img {
  width: 502px;
  height: 100%;
}

.iconHover:hover {
  color: #519cf3;
}

.html-scroll {
  // height: 100%;
  width: 100%;
  // overflow: hidden;
  overflow-y: auto !important;
  .scroll-code {
    overflow-y: scroll;
    // width: 100%;
    height: 390px;
  }
}
</style>